import NewHeader from "../components/NewHeader_dev";
import BoardCSS from "./Board_dev.module.css";
import Footer from "../components/Footer";
import Loader from '../components/Loader'
import React,{useState,useEffect} from 'react'

function Board() {
  return (
    <div className={BoardCSS.content}>
      <NewHeader />
      <br />
      <div>
            <p>
              <table>
                <tr>
                  <th>
                  번호
                  </th>
                  <th>
                  카테고리
                  </th>
                  <th>
                  내용
                  </th>
                </tr>
                <tr>
                  <td>1</td>
                  <td>논문</td>
                  <td>
                  <div class="board-container">
                    <details>
                      <summary>Smartooth 논문 1 2025 연세대 논문 Optimizing-fluorescence-based-caries-detection</summary>
                      <div class="content2">
                        <a href="https://www.smartooth.co/download/Smartooth 논문 1 2025 연세대 논문 Optimizing-fluorescence-based-caries-detection.pdf" target="_blank">내용 보기</a>
                      </div>
                    </details>
                  </div>
                  </td>
                </tr>
                <tr>
                  <td>2</td>
                  <td>논문</td>
                  <td>
                  <div class="board-container">
                    <details>
                      <summary>Smartooth 논문 2 2025 Diagnodentic Performance of a laser fluorescence device</summary>
                      <div class="content2">
                        <a href="https://www.smartooth.co/download/Smartooth 논문 2 2025 Diagnodentic Performance of a laser fluorescence device.pdf" target="_blank">내용 보기</a>
                      </div>
                    </details>
                  </div>
                  </td>
                </tr>
                <tr>
                  <td>3</td>
                  <td>논문</td>
                  <td>
                  <div class="board-container">
                    <details>
                      <summary>ijcpd-21-2-31 단국대 논문 2025</summary>
                      <div class="content2">
                        <a href="https://www.smartooth.co/download/ijcpd-21-2-31 단국대 논문 2025.pdf" target="_blank">내용 보기</a>
                      </div>
                    </details>
                  </div>
                  </td>
                </tr>
                <tr>
                  <td>4</td>
                  <td>논문</td>
                  <td>
                  <div class="board-container">
                    <details>
                      <summary>JKAPD-2026-53-1- 박진아선생님</summary>
                      <div class="content2">
                        <a href="https://www.smartooth.co/download/JKAPD-2026-53-1- 박진아선생님.pdf" target="_blank">내용 보기</a>
                      </div>
                    </details>
                  </div>
                  </td>
                </tr>
              </table>
            </p>
            <br />
            <br />
          <Footer />
      </div>
    </div>
  );
}
export default Board;
